<!--
 * @Author: wangyanhui
 * @objectDescription: 
 * @Date: 2024-04-10 21:15:39
 * @LastEditors: wangyanhui
 * @LastEditTime: 2024-05-17 17:49:21
 * @FilePath: /振瀚信息项目/tccc/src/layout/bottom-menu/layout.vue
 * @Version: 1.0
-->
<template>
  <div class="layout">
    <transition name="fade-slide" mode="out-in">
      <router-view class="layout-page" />
    </transition>
    <van-tabbar route fixed>
      <!-- 拨号盘tab - 根据座席类型显示/隐藏 -->
      <van-tabbar-item
        v-if="showAllTabs"
        to="/index"
        @selectstart.native="preventSelect"
        @mousedown.native="preventSelect"
      >
        <span>{{ $t('keypad') }}</span>
        <template #icon>
          <span class="material-icons bottom-icon">dialpad</span>
        </template>
      </van-tabbar-item>
      <!-- 记录tab - NORMAL和DUTY类型座席都可以看到 -->
      <van-tabbar-item
        v-if="showRecordsTab"
        to="/records"
        @selectstart.native="preventSelect"
        @mousedown.native="preventSelect"
      >
        <span>{{ $t('recordofrecord') }}</span>
        <template #icon>
          <span class="material-icons bottom-icon">history</span>
        </template>
      </van-tabbar-item>
      <!-- 联系人tab - 根据座席类型显示/隐藏 -->
      <van-tabbar-item
        v-if="showAllTabs"
        to="/contactPerson"
        @selectstart.native="preventSelect"
        @mousedown.native="preventSelect"
      >
        <span>{{ $t('contacts') }}</span>
        <template #icon>
          <span class="material-icons bottom-icon">contacts</span>
        </template>
      </van-tabbar-item>
      <!-- 我的tab - 始终显示 -->
      <van-tabbar-item
        to="/individualCenter"
        @selectstart.native="preventSelect"
        @mousedown.native="preventSelect"
      >
        <span>{{ $t('me') }}</span>
        <template #icon>
          <span class="material-icons bottom-icon">person</span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Vue from 'vue';
import { Tabbar, TabbarItem } from 'vant';
import { PhoneTelephone, AddressBook, Me, Log, History } from '@icon-park/vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import Cookies from 'js-cookie'
import util from '@/libs/util.js'

Vue.use(Tabbar);
Vue.use(TabbarItem);

export default {
  name: 'layout',
  mixins: [],
  components: {
    
  },
  provide() {
    return {
      refreshView: this.refreshView
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState('tccc', {
      info: state => state.user.info,
      seatList: state => state.individualCenter?.seatList || []
    }),

    // 检查用户是否有NORMAL类型的座席
    hasNormalSeat() {
      if (!this.seatList || this.seatList.length === 0) {
        return false;
      }
      // 检查是否有任何座席的 seat_type 是 NORMAL
      return this.seatList.some(seat => seat.seat_type === 'NORMAL');
    },

    // 是否显示所有tab（除了我的tab）
    showAllTabs() {
      return this.hasNormalSeat;
    },

    // 是否显示记录tab（NORMAL和DUTY类型座席都可以看到）
    showRecordsTab() {
      if (!this.seatList || this.seatList.length === 0) {
        return false;
      }
      return this.seatList.some(seat => seat.seat_type === 'NORMAL' || seat.seat_type === 'DUTY');
    }
  },
  methods: {
    ...mapActions('tccc/individualCenter', ['getTheUserSeatList']),

    // 阻止文本选择
    preventSelect(e) {
      e.preventDefault();
      return false;
    },

    // 获取用户座席数据
    async loadUserSeatData() {
      try {
        if (this.info && this.info.userid) {
          console.log('底部导航组件 - 开始加载用户座席数据...');
          await this.getTheUserSeatList([this.info.userid]);
          console.log('底部导航组件 - 用户座席列表已加载:', this.seatList);
          console.log('底部导航组件 - 座席数量:', this.seatList?.length || 0);
          console.log('底部导航组件 - 是否有NORMAL座席:', this.hasNormalSeat);

          // 数据加载完成后，延迟一点时间确保响应式更新完成
          this.$nextTick(() => {
            // 检查是否需要自动跳转到个人中心页面
            this.checkAndRedirect();
          });
        } else {
          console.warn('底部导航组件 - 用户信息不完整，无法加载座席数据');
        }
      } catch (error) {
        console.error('加载用户座席数据失败:', error);
      }
    },

    // 检查并自动跳转到个人中心页面
    checkAndRedirect() {
      console.log('底部导航组件 - 执行跳转检查');
      console.log('底部导航组件 - 当前路由:', this.$route.path);
      console.log('底部导航组件 - 座席列表:', this.seatList);
      console.log('底部导航组件 - 座席数量:', this.seatList?.length || 0);
      console.log('底部导航组件 - 是否有NORMAL座席:', this.hasNormalSeat);

      // 检查seatList是否已初始化（非undefined）
      const isSeatListLoaded = this.seatList !== undefined;

      if (isSeatListLoaded) {
        // 数据已加载，检查是否需要跳转
        // 排除值班电话页面和记录页面，因为这些页面DUTY类型座席也可以访问
        const isDutyPhonePage = this.$route.path === '/dutyPhone';
        const isRecordsPage = this.$route.path === '/records';

        if (!this.hasNormalSeat && this.$route.path !== '/individualCenter' && !isDutyPhonePage && !isRecordsPage) {
          console.log('用户没有NORMAL类型座席，自动跳转到个人中心页面');
          this.$router.push('/individualCenter');
        } else if (this.hasNormalSeat) {
          console.log('用户有NORMAL类型座席，无需跳转');
        } else if (isDutyPhonePage) {
          console.log('当前在值班电话页面，DUTY类型座席无需跳转');
        } else if (isRecordsPage) {
          console.log('当前在记录页面，DUTY类型座席无需跳转');
        } else {
          console.log('数据已加载但hasNormalSeat为false，保持当前页面');
        }
      } else {
        console.log('座席数据尚未初始化，跳过跳转检查');
      }
    }
  },

  watch: {
    // 监听路由变化，检查是否需要跳转
    '$route'(to, from) {
      // 如果座席数据已初始化（包括空数组），检查是否需要跳转
      if (this.seatList !== undefined) {
        this.checkAndRedirect();
      }
    },

    // 监听座席数据变化
    seatList: {
      // 移除immediate，避免在数据未加载时触发
      handler(newSeatList) {
        // 当数据发生变化时（包括变为[]），都进行检查
        if (newSeatList !== undefined) {
          console.log('座席数据已更新:', newSeatList);
          console.log('座席数据长度:', newSeatList?.length || 0);
          this.checkAndRedirect();
        }
      }
    }
  },

  mounted() {
    console.log(this.$languages, 'this.$languagesthis.$languages')
    console.log(this.$i18n.locale, 'this.$i18n.locale')
    
    // 加载用户座席数据
    this.loadUserSeatData();
  },
  destroyed() {
    // 离开路由之后断开websocket连接
    // this.$websocket.close()
  }
}
</script>

<style lang="scss">
// 注册主题
// @import "~@/assets/style/theme/register.scss";
.layout {
  height: calc(100% - 1.33333rem - env(safe-area-inset-bottom));

  .layout-page {
    height: 100%;
    overflow: auto;
  }
}

// 自定义底部样式，贴近原型
.van-tabbar {
  background: #ffffff !important;
  border-top: 1px solid #e5e7eb;
  padding: 0.1rem 0;
  
  /* iPhone安全区域兼容 */
  padding-bottom: calc(0.1rem + env(safe-area-inset-bottom));
  /* 兼容旧版本iOS */
  padding-bottom: calc(0.1rem + constant(safe-area-inset-bottom));
}

.van-tabbar-item {
  padding: 0.15rem 0;
  color: #9ca3af;
  font-size: 0.275rem;
  /* 确保按钮内容不被安全区域遮挡 */
  min-height: 1.1rem; /* iOS推荐的最小触摸目标 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.van-tabbar-item--active {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.08), rgba(29, 78, 216, 0.04));
  border-radius: 0.3rem;
  color: #2563eb;
}

.van-tabbar-item span {
  -webkit-user-select: none !important;
  user-select: none !important;
}

.bottom-icon {
  font-family: 'Material Icons';
  font-size: 0.55rem;
  line-height: 1;
}

/* 页面切换过渡动画（渐入+轻微位移） */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}
.fade-slide-enter {
  opacity: 0.01;
  transform: translateY(0.15rem);
}
.fade-slide-leave-to {
  opacity: 0.01;
  transform: translateY(-0.15rem);
}

/* iPhone安全区域额外兼容 */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .van-tabbar {
    padding-bottom: calc(0.1rem + env(safe-area-inset-bottom)) !important;
  }
  
  .layout {
    height: calc(100vh - 1.55rem - env(safe-area-inset-bottom)) !important;
  }
}

/* 兼容更老的iOS版本 */
@supports (padding-bottom: constant(safe-area-inset-bottom)) {
  .van-tabbar {
    padding-bottom: calc(0.1rem + constant(safe-area-inset-bottom)) !important;
  }
  
  .layout {
    height: calc(100vh - 1.55rem - constant(safe-area-inset-bottom)) !important;
  }
}
</style>
